import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { API_URL } from '../../core.tokens';
import { TokenResponse } from '../../models/token-response.model';

@Injectable()
export class AuthService {

  constructor(
    private http: HttpClient,
    @Inject(API_URL) private apiUrl: string
  ) { }

  login(username: string, password: string): Observable<TokenResponse> {
    const body = { username, password };
    return this.http.post<TokenResponse>(`${this.apiUrl}/auth/login`, body).pipe(first());
  }

  changePassword(username: string, oldPassword: string, newPassword: string): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(`${this.apiUrl}/auth/change-password`, { username, oldPassword, newPassword }).pipe(first());
  }
}
